<template>
  <div class="Background">

    <div class="title_link">

      <h2 class="Title">
        인증서 세부 정보 입력
      </h2>

      <div class="link_location">
        설정관리
        <v-icon small class="mdi mdi-chevron-right"/>
        시스템관리
        <v-icon small class="mdi mdi-chevron-right"/>
        인증서 관리
        <v-icon small class="mdi mdi-chevron-right"/>
        <a href="/cert/cert_import">세부 정보 입력</a>
      </div>

    </div>

    <div class="suport_box">
      <strong>PEM 인코딩 인증서</strong> 본문, 개인 키 및 인증서연결을 아래에 붙여넣습니다.
    </div>


    <v-card class="pa-5" elevation="0">

      <v-row>
        <v-col class="mb-4" cols="12">
          <h4 class="mb-2" style="color:black;">인증서 본문</h4>
          <textarea name="input-7-1" placeholder="PEM으로 인코딩된 인증서 본문을 붙여넣습니다." outlined
            v-model="cert" :rules="certRule" ref="certInput" class="textarea"></textarea>
          <v-snackbar v-model="snackbar" bottom right color="error" :timeout="3000">
            {{ snackbarText }}
          </v-snackbar>
        </v-col>
        <v-col class="mb-4" cols="12">
          <h4 class="mb-2" style="color:black;">인증서 개인 키</h4>
          <textarea name="input-7-1" placeholder="PEM으로 인코딩된 인증서 본문을 붙여넣습니다." outlined
            v-model="public_key" :rules="keyRule" ref="keyInput" class="textarea"></textarea>
        </v-col>
        <v-col class="mb-4" cols="12">
          <h4 class="mb-2" style="color:black;">인증서 연결 - 선택 사항
          </h4>
          <textarea name="input-7-1" placeholder="PEM 암호화 인증서 연결을 붙여넣습니다." outlined
            v-model="chain" height="10" class="textarea"></textarea>
        </v-col>
      </v-row>

    </v-card>

    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <TextButton buttonText="취소" @click="cancel" class="mr-2"/>
        <!--router-link to="/cert/cert_tags"-->
        <TextButton buttonText="다음" @click="next" :loading="loadingDelete" isPrimary />
        <!-- </router-link> -->
      </v-col>
    </v-row>

  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton.vue';

export default {
  components: {
        TextButton,
    },
}
</script>

<style lang="scss" scoped>
.textarea {
    width: 100%;
    height: 60px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
}
input:focus  {
    outline: none;
    border: 1px solid #999;
}
</style>